<template>
  <!-- 个人类型用户提现 -->
  <el-dialog class="fapiaoInfo bank-modal" width="700px" show-close :visible.sync="visible">
    <div class="titless" style="margin-bottom: 15px">
      <i></i>
      <span>确认提现信息</span>
    </div>
    <el-form :inline="true" :model="bankData" label-width="100px" ref="bankForm" label-position="right">
      <el-form-item label="户主姓名" prop="bankUserName" :rules="[rules.required('未填写户主姓名')]">
        <el-input v-model="bankData.bankUserNameBak" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="银行账号" prop="bankAccount" :rules="[rules.required('未填写银行账号'), rules.num('银行账号为数字')]">
        <el-input v-model="bankData.bankAccountBak" :disabled="true" :maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="开户银行" prop="bankType" :rules="[rules.required('未填写开户银行')]">
        <el-input v-model="bankData.bankType" :disabled="true" :maxlength="30"></el-input>
      </el-form-item>

      <el-form-item label="开户行地址" prop="bankAddress" :rules="[rules.required('未填写开户行地址')]">
        <el-input v-model="bankData.bankAddress" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="身份证" prop="idCardNo" :rules="[rules.required('未填写身份证')]" v-if="mechanUserType == 2 || mechanUserType == 3">
        <el-input v-model="bankData.idCardNoBak" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="执业证编号" prop="certificateNo" :rules="[rules.required('未填写执业证编号')]" v-if="mechanUserType == 2 || mechanUserType == 3">
        <el-input v-model="bankData.certificateNoBak" :disabled="true"></el-input>
      </el-form-item>
      <div class="btn-list">
        <el-button type="warning" @click="submit()" :loading="loading">确定</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import { ruleTool } from '@/api/mixins';
export default {
  mixins: [ruleTool],
  components: {},
  data: () => ({
    loading: false,
    visible: false,
    level: '',
    mechanUserType: '',
    bankData: {},
    formData: {}
  }),
  created() {
    const user = this.$tools.getLocal('userinfo');
    this.level = user.level;
    this.mechanUserType = user.mechanUserType; //1机构2，3个人
  },
  methods: {
    open(data) {
      this.formData = {
        relatedImageUrls: '',
        expressCompany: '',
        courierNumber: '',
        cashBalanceIds: data.balanceIds.join(","),
        cashPlatType: 1 // 1:pc 2微信  3:app
      };
      this.getBankInfo();
      this.visible = true;
    },
    getBankInfo() {
      this.$http({
        url: '/master/means/getBankInfo',
        type: 'put',
        params: {}
      }).then(res => {
        const data = res.data;
        data.toucherNameBak = '*' + data.toucherName.substring(1);
        data.toucherMobileBak = data.toucherMobile.substring(0, 3) + '****' + data.toucherMobile.substring(7);
        if (data.bankAccount && data.bankAccount.length > 8) {
          //银行卡
          data.bankAccountBak =
            data.bankAccount.substring(0, 4) + '*'.repeat(data.bankAccount.length - 8) + data.bankAccount.substring(data.bankAccount.length - 4);
        } else {
          data.bankAccountBak = data.bankAccount;
        }
        if (data.bankUserName) {
          //户主姓名
          data.bankUserNameBak = '*' + data.bankUserName.substring(1);
        } else {
          data.bankUserNameBak = data.bankUserName;
        }
        if (data.idCardNo && data.idCardNo.length > 10) {
          //身份证
          data.idCardNoBak = data.idCardNo.substring(0, 6) + '*'.repeat(data.idCardNo.length - 10) + data.idCardNo.substring(data.idCardNo.length - 4);
        } else {
          data.idCardNoBak = data.idCardNo;
        }
        if (data.certificateNo && data.certificateNo.length > 8) {
          //执业证编号
          data.certificateNoBak =
            data.certificateNo.substring(0, 4) + '*'.repeat(data.certificateNo.length - 8) + data.certificateNo.substring(data.certificateNo.length - 4);
        } else {
          data.certificateNoBak = data.certificateNo;
        }
        this.bankData = data;
        if (this.$refs['bankForm']) {
          this.$refs['bankForm'].clearValidate();
        }
      });
    },
    //提交
    submit() {
      this.$refs['bankForm'].validate(valid => {
        if (!valid) {
          this.$message.error('银行账户信息有误，请联系客服');
          return;
        }
        const data = JSON.parse(JSON.stringify(this.formData));
        data.cashPlatType = 1; // 1:pc 2微信  3:app
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          url: '/master/means/applyCashPostal',
          type: 'put',
          params: data
        })
          .then(data => {
            this.visible = false;
            this.$emit('reload');
          })
          .finally(() => {
            window.setTimeout(() => {
              this.loading = false;
            }, 500);
          });
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.fapiaoInfo /deep/ {
  .el-dialog__body {
    padding: 0 30px 20px;
  }

  .titless {
    margin-bottom: 10px;
    i {
      display: inline-block;
      width: 4px;
      height: 16px;
      background: #ff9700;
      vertical-align: middle;
      margin-right: 10px;
    }

    span {
      font-size: 16px;
      vertical-align: middle;
    }

    &.child {
      margin-top: 10px;
    }

    &.child2 {
      margin-top: 20px;
      margin-bottom: 15px;
    }

    &.child3 {
      margin-bottom: 15px;
    }

    a {
      color: #009cfe;
    }
  }

  .df-inp {
    width: 400px;
    margin-right: 40px;
    margin-bottom: 20px;
    vertical-align: top;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
  }

  .el-input-group__prepend {
    width: 110px;
  }

  .df-select {
    /deep/ .el-input__prefix {
      background-color: #f5f7fa;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 1px solid #dcdfe6;
      position: absolute;
      left: 0;
      top: 0;
      width: 110px;
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
      padding: 0 15px;
    }

    /deep/ .el-input__inner {
      padding-left: 125px;
    }
  }

  .seal-input {
    .seal-title {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .img-list {
      text-align: left;

      .img-item {
        display: inline-block;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;

        img {
          width: 120px;
          height: 120px;
        }

        i {
          display: block;
          position: absolute;
          right: 0;
          top: 0;
          background-color: rgba(0, 0, 0, 0.5);
          text-align: right;
          font-size: 20px;
          color: #fff;
        }

        &:hover {
          i {
            display: block;
          }
        }
      }
    }

    .seal-uploader {
      .seal-upload-btn {
        width: 120px;
        height: 120px;
        display: inline-flex;
        vertical-align: top;
        justify-content: center;
        align-items: center;
        border: 1px solid #ddd;
        font-size: 50px;

        .el-icon-plus {
          color: #ddd;
        }
      }
    }
  }

  .rules {
    font-size: 14px;
    line-height: 24px;
    margin-top: 20px;

    a {
      color: #009cfe;
    }
  }

  .flagButton {
    text-align: center;
    margin-top: 40px;

    .el-button--small {
      padding: 15px 80px;
    }

    p {
      margin-top: 10px;
    }
  }
}
.bank-modal {
  .info-text {
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 20px;

    a {
      color: #009cfe;
    }
  }

  .el-form-item__error {
    display: none;
  }

  .el-input,
  .el-select {
    width: 206px;
  }

  .code-box {
    .el-input-group__append {
      background-color: #e6a23c;
      border-color: #e6a23c;
      color: #fff;
      width: 85px;
      text-align: center;
    }

    &.huibtn {
      .el-input-group__append {
        background: #ccc;
        border-color: #ccc;

        .el-button {
          cursor: default;
        }
      }
    }
  }

  .btn-list {
    width: 100%;
    padding-right: 15px;
    margin-top: 10px;
    text-align: center;

    .el-button {
      width: 200px;
    }
  }
}
</style>